import React, { cloneElement } from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import { Grid, TextField, Button } from '@material-ui/core';
import Utils from '../../providers/Utils';
import FromServer from './FromServer';
import Calendar from 'react-calendar';
import ProjectDateChange from '../../commons/dialogs/ProijectDateChange';
// import DatePicker from 'react-date-picker';
import ro from 'date-fns/locale/ro';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import AlertDialog from '../../commons/dialogs/AlertDialog';
import LocalStorage from '../../providers/LocalStorage';



import { ReactComponent as Step1 } from '../../Pics/iconsManagement/step1.svg';
import { ReactComponent as Step2Gray } from '../../Pics/iconsManagement/step2_gray.svg';
import { ReactComponent as Step3Gray } from '../../Pics/iconsManagement/step3_gray.svg';
import { ReactComponent as Step4Gray } from '../../Pics/iconsManagement/step4_gray.svg';

registerLocale('ro', ro)




export default class InformatiiProiect extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            proiect: {},
            dtStartDate: new Date(),
            dtFinishDate: new Date(),
            showCalendars: false,
            activeStep: 0,
            steps: [
                { id: 0, done: false, icon: <Step1 style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoProiect' },
                { id: 1, done: false, icon: <Step2Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToUtilizatori' },
                { id: 2, done: false, icon: <Step3Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoEtape' },
                { id: 3, done: false, icon: <Step4Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoBuget' }
            ],
            isOpenAlert: false,
            message: ''
        }
    }

    componentDidMount() {

        this.getInfoProiect()
    }


    getIcons = () => {



        return this.state.steps.map((s, idx) => {

            return (
                <div key={idx} style={{display:'inline-block'}} onClick={this.props[s.goTo]}>
                    {s.icon}

                </div>
                // <i onClick={this.props[s.goTo]} key={idx} style={{ color: this.state.activeStep === s.id ? 'black' : (s.done ? 'rgb(24 165 58 )' : 'gray') }} className='material-icons new-project-icons'>{s.icon}</i>
            )
        })
    }



    handleChange = nume => ev => {

        let cloneProiect = { ...this.state.proiect }

        cloneProiect[nume] = ev.target.value

        this.setState({ proiect: cloneProiect })
    }

    getInfoProiect = async () => {

        let fS = new FromServer();

        let u = new Utils();

        let getInfoProiect = await fS.getInfoProiect(this.props.idproiect);

        console.log('getInfoProiect :', getInfoProiect);



        let cloneProiect = getInfoProiect[0]

        cloneProiect.perioada_dela = u.ParseDataFromSql(cloneProiect.perioada_dela)

        cloneProiect.perioada_panala = u.ParseDataFromSql(cloneProiect.perioada_panala)

        this.setState({
            proiect: cloneProiect,
            dtStartDate: new Date(cloneProiect.perioada_dela),
            dtFinishDate: new Date(cloneProiect.perioada_panala)
        })


    }


    saveInformatii = async () => {


        let fS = new FromServer();
        let u = new Utils()




        let obj = {
            descriere: this.state.proiect.descriere || '',
            perioada_dela: u.transformDataForSql(this.state.proiect.perioada_dela),
            perioada_panala: u.transformDataForSql(this.state.proiect.perioada_panala),
            titlu: this.state.proiect.titlu,
            beneficiar_proiect: this.state.proiect.beneficiar_proiect || '',
            cod_proiect: this.state.proiect.cod_proiect || '',

        }

        console.log('obj :', obj);

        let save = await fS.saveInformatiiProiect(obj, this.props.idproiect)

        // console.log('save :', save);

        if (save.Succes) {
            this.props.goToUtilizatori()
        }

    }


    stergeProiect = async () => {
        let ws = new Ws();

        let deleteP = await ws.update('proiecte', { sters: 1 }, { id: this.props.idproiect })

        if (deleteP.Succes) {
            this.props.history.push('/projects')
        }
    }

    handleDate = (ev, name) => {
        // console.log('ev :', ev);
        // console.log('name :', name);

        if (name === 'perioada_dela') {


            let perioadaPanaLa = this.state.proiect.perioada_panala

            console.log('perioadaPanaLa :>> ', new Date(perioadaPanaLa));
            console.log('ev :>> ', ev);


            if (ev > new Date(perioadaPanaLa)) {
                this.setState({
                    isOpenAlert: true,
                    message: 'Data de inceput nu poate fi mai mare decat data de sfarsit'
                })
            } else {

                let obj = { ...this.state.proiect }
                obj[name] = new Utils().transformDataForSql(ev)

                // console.log('obj :', obj);

                this.setState({ proiect: obj })
            }



        } else {

            let perioadaDeLa = this.state.proiect.perioada_dela

            console.log('perioadaPanaLa :>> ', new Date(perioadaDeLa));
            console.log('ev :>> ', ev);


            if (ev < new Date(perioadaDeLa)) {
                this.setState({
                    isOpenAlert: true,
                    message: 'Data de sfarsit nu poate fi mai mica decat data de inceput'
                })
            } else {

                let obj = { ...this.state.proiect }
                obj[name] = new Utils().transformDataForSql(ev)

                // console.log('obj :', obj);

                this.setState({ proiect: obj })
            }

        }




    }


    buttonDisabled = () => {

        if (this.state.proiect.titlu !== null &&
            this.state.proiect.descriere !== null &&
            this.state.proiect.beneficiar_proiect !== null &&
            this.state.proiect.cod_proiect !== null &&
            this.state.proiect.perioada_dela !== null &&
            this.state.proiect.perioada_panala !== null
        ) {
            return false
        } else {
            return true
        }
    }

    colorButton = () => {
        if (this.state.proiect.titlu !== null &&
            this.state.proiect.descriere !== null &&
            this.state.proiect.beneficiar_proiect !== null &&
            this.state.proiect.cod_proiect !== null &&
            this.state.proiect.perioada_dela !== null &&
            this.state.proiect.perioada_panala !== null
        ) {
            return '#07B14B'
        } else {
            return 'gray'
        }
    }


    render() {
        return (
            <div>

                {this.state.proiect &&
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white' }}>

                        <AlertDialog
                            open={this.state.isOpenAlert}
                            dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                            title={this.state.message}
                            limba={this.dictionary}
                            yesFunction={() => { this.setState({ isOpenAlert: false }) }}
                            noButtonDisplay={1}
                        />


                        <div style={{ position: 'absolute', top: -20, left: 0, right: 0, margin: "auto" }}>
                            {this.getIcons()}
                        </div>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 40 }}>
                                {this.dictionary.proiecte.dateDespreNoulProiect}

                            </h4>
                        </Grid>


                        <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 15 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid container>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}> {this.dictionary.proiecte.denumireProiect}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>

                                    <input
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        value={this.state.proiect.titlu || ""}
                                        onChange={this.handleChange('titlu')}
                                        placeholder={this.dictionary.proiecte.exPoianaMarului}
                                    />

                                    {/* <TextField
                                        className="loginTextField inputFocus proiectInput"
                                        style={{ marginBottom: 0, marginTop: 0, marginLeft: 5 }}
                                        id='titlu-proiect'
                                        type="text"
                                        margin="normal"
                                        value={this.state.proiect.titlu || ""}
                                        onChange={this.handleChange('titlu')}
                                    /> */}
                                </Grid>
                            </Grid>





                        </Grid>

                        <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.projectDescription}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                    <textarea
                                        className='add-project-input'
                                        margin="normal"
                                        value={this.state.proiect.descriere || ""}
                                        onChange={this.handleChange('descriere')}
                                        style={{ minHeight: 100 }}
                                        placeholder={this.dictionary.proiecte.projectDescriptionPlaceHolder}
                                    >

                                    </textarea>

                                </Grid>
                            </Grid>

                            {/* <label htmlFor='descriere-proiect'>
                                <span style={{
                                    display: 'inline-flxe',
                                    verticalAlign: 'bottom',
                                    fontSize: 18,
                                    fontWeight: 600,
                                    color: '#6b6363'
                                }}>{this.dictionary.proiecte.informatiiProiect.descriere + ' Proiect: '} </span>

                                <TextField
                                    className="loginTextField inputFocus proiectInput"
                                    multiline
                                    id="descriere-proiect"
                                    style={{ marginBottom: 0 }}
                                    type="text"
                                    margin="normal"
                                    value={this.state.proiect.descriere || ""}
                                    onChange={this.handleChange('descriere')}
                                />
                            </label> */}
                        </Grid>

                        <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 15 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid container>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.beneficiarProiect}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                    <input
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        value={this.state.proiect.beneficiar_proiect || ""}
                                        onChange={this.handleChange('beneficiar_proiect')}
                                        placeholder={this.dictionary.proiecte.beneficiarProiectPlaceHolder}
                                    />


                                </Grid>

                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                </Grid>


                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                    <input
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        value={this.state.proiect.cod_proiect || ""}
                                        onChange={this.handleChange('cod_proiect')}
                                        placeholder={this.dictionary.proiecte.cui}

                                    />


                                </Grid>


                            </Grid>





                        </Grid>

                        <Grid style={{ textAlign: 'left', paddingLeft: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid container>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.dataInceputProiect}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                    <DatePicker

                                        className='add-project-input'
                                        style={{ width: '100%' }}
                                        selected={this.state.proiect.perioada_dela ? new Date(this.state.proiect.perioada_dela) : new Date()}
                                        onChange={(ev) => { this.handleDate(ev, 'perioada_dela') }}
                                        startDate={this.state.proiect.perioada_dela}
                                        shouldCloseOnSelect={true}
                                        calendarClassName="calendar-left-absolute"
                                        locale="ro"
                                        disabled={this.props.readOnly}
                                        dateFormat="dd/MM/yyyy"
                                        customInput={<div className='date-picker'>

                                            <span>


                                                {this.state.proiect.perioada_dela}

                                                {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                            </span>

                                            <i style={{

                                                fontSize: 18,
                                                verticalAlign: 'middle'

                                            }} className='material-icons'>today</i>
                                        </div>}
                                        monthsShown={2}
                                    />
                                    {/* <DatePicker
                                        className='date-picker'
                                        style={{ width: '100%' }}
                                        name='perioada_dela'
                                        locale='ro'
                                        value={this.state.proiect.perioada_dela ? new Date(this.state.proiect.perioada_dela) : new Date()}
                                        onChange={(ev) => { this.handleDate(ev, 'perioada_dela') }}
                                        calendarIcon={<i className='material-icons' style={{ fontSize: 18 }} >calendar_today</i>}
                                        clearIcon={null} /> */}
                                </Grid>

                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            paddingLeft: 20,
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.dataSfarsitProiect}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                                    <DatePicker

                                        className='add-project-input'
                                        style={{ width: '100%' }}
                                        selected={this.state.proiect.perioada_panala ? new Date(this.state.proiect.perioada_panala) : new Date()}
                                        onChange={(ev) => { this.handleDate(ev, 'perioada_panala') }}
                                        startDate={this.state.proiect.perioada_panala}
                                        shouldCloseOnSelect={true}
                                        calendarClassName="calendar-left-absolute"
                                        locale="ro"
                                        disabled={this.props.readOnly}
                                        dateFormat="dd/MM/yyyy"
                                        customInput={<div className='date-picker'>

                                            <span>


                                                {this.state.proiect.perioada_panala}

                                                {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                            </span>

                                            <i style={{

                                                fontSize: 18,
                                                verticalAlign: 'middle'

                                            }} className='material-icons'>today</i>
                                        </div>}
                                        monthsShown={2}
                                    />
                                    {/* <DatePicker
                                        className='date-picker'
                                        style={{ width: '100%' }}
                                        name='perioada_panala'
                                        locale='ro'
                                        value={this.state.proiect.perioada_panala ? new Date(this.state.proiect.perioada_panala) : new Date()}
                                        onChange={(ev) => { this.handleDate(ev, 'perioada_panala') }}
                                        calendarIcon={<i className='material-icons' style={{ fontSize: 18 }} >calendar_today</i>}
                                        clearIcon={null} /> */}
                                </Grid>
                            </Grid>





                        </Grid>



                        {/* <Grid style={{ display: this.props.showSave ? 'none' : 'block', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                            <Button variant="outlined" className='pm-save-button' color="primary" onClick={this.saveInformatii}>
                                {this.dictionary.comune.save}
                            </Button>

                            <Button style={{ marginLeft: 10 }} variant="outlined" className='pm-delete-button' color="primary" onClick={this.stergeProiect}>
                                {this.dictionary.comune.sterge}
                            </Button>


                        </Grid> */}
                    </Grid>
                }

                <Grid container style={{ marginTop: 40, textAlign: 'left' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Button disabled={this.buttonDisabled()}
                            style={{ backgroundColor: this.colorButton(), fontSize:14, fontWeight:400, boxShadow:'none' }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.saveInformatii}>
                            {this.dictionary.proiecte.step2Project}
                        </Button>
                    </Grid>
                </Grid>

                <ProjectDateChange
                    open={this.state.showCalendars}
                    dialogClose={() => { this.setState({ showCalendars: false }) }}
                    changeDataInceput={(ev) => { this.setState({ dtStartDate: ev }) }}
                    dtStartDate={this.state.dtStartDate}
                    changeDataSfarsit={(ev) => { this.setState({ dtFinishDate: ev }) }}
                    dtFinishDate={this.state.dtFinishDate}
                    dictionary={this.dictionary} />

            </div>
        );
    }
}